// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditIndexerModalContent-deleteButton-20PDW Button-button-2PYOE Link-link-1rgM9"};